<template>

    <div class="header-wrapper pb-60">

        <header class="header">
            <div class="container header-inner">

                <router-link v-if="!loading" :to="{ name: 'home' }" class="logo" :aria-label="$brand">
                    <img v-if="!agency" src="/img/mgr-logo.svg" height="50" width="auto" :alt="$brand" />
                    <div v-else class="d-flex align-items-center">
                        <img v-if="agencyIcon" class="mr-10" :src="agencyIcon" height="30" width="auto" :alt="agencyName" />
                        <span>{{ agencyName }}</span>
                    </div>
                </router-link>
                <div v-else></div>

                <div v-if="apiKey && $route.name === 'setup'" class="d-flex align-items-center justify-content-end">
                    <v-dropdown-user logout-only />
                </div>

                <div v-else-if="apiKey && !['login', 'signup', 'mfa'].includes($route.name)" class="d-flex align-items-center justify-content-end">
                    <div class="nav">
                        <div class="nav-item">
                            <router-link class="nav-link accent" :to="{ name: 'dashboard' }">
                                <span>{{ $t('labels.dashboard') }}</span>
                            </router-link>
                        </div>
                    </div>
                </div>

                <div v-if="!apiKey && !agency" class="d-flex align-items-center justify-content-end">
                    <div class="nav">
                        <div class="nav-item d-none d-md-flex">
                            <a class="nav-link" href="https://moregoodreviews.com/showcase/moregoodreviews" target="_blank">
                                <span>{{ $t('labels.our_reviews') }}</span>
                            </a>
                        </div>
                        <div class="nav-item d-none d-md-flex">
                            <router-link class="nav-link" :class="{ active: $route.name === 'pricing' }" :to="{ name: 'pricing' }">
                                <span>{{ $t('labels.pricing') }}</span>
                            </router-link>
                        </div>
                        <div class="nav-item d-none d-md-flex">
                            <router-link class="nav-link" :class="{ active: $route.name === 'login' }" :to="{ name: 'login' }">
                                <span>{{ $t('labels.log_in') }}</span>
                            </router-link>
                        </div>
                        <div class="nav-item d-none d-md-flex">
                            <router-link class="nav-link accent" :to="{ name: 'signup' }">
                                <span>{{ $t('labels.start_free_trial') }}</span>
                            </router-link>
                        </div>
                        <div class="nav-item">
                            <v-dropdown-lang />
                        </div>
                    </div>
                    <v-hamburger v-if="!apiKey && !agency">
                        <router-link class="dropdown-item" :to="{ name: 'signup' }">{{ $t('labels.start_free_trial') }}</router-link>
                        <router-link class="dropdown-item" :to="{ name: 'login' }">{{ $t('labels.log_in') }}</router-link>
                        <router-link class="dropdown-item" :to="{ name: 'pricing' }">{{ $t('labels.pricing') }}</router-link>
                        <a class="dropdown-item" :href="$docsUrl" target="_blank">{{ $t('labels.documentation') }}</a>
                        <router-link class="dropdown-item" :to="{ name: 'contact' }">{{ $t('labels.contact_us') }}</router-link>
                    </v-hamburger>
                </div>

                <div v-if="!apiKey && agency" class="d-flex align-items-center justify-content-end">
                    <div class="nav">
                        <div class="nav-item">
                            <v-dropdown-lang />
                        </div>
                    </div>
                </div>

            </div>
        </header>

    </div>

</template>

<style scoped lang="scss">

    .header {
        background: $color-white;
        box-shadow: 0 1px 2px rgba(0,0,0,0.2);
        height: 60px;
        left: 0;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 2;
        .header-inner {
            align-items: center;
            display: flex;
            height: 100%;
            justify-content: space-between;
        }
        .nav {
            align-items: center;
            .nav-item {
                @include font-semibold(12px);
                margin: 0;
                padding: 0;
            }
            .nav-link {
                align-items: center;
                color: $color-text;
                display: flex;
                justify-content: center;
                height: 40px;
                margin: 0;
                padding: 0 10px;
                transition: background-color .3s, color .3s;
                &:hover, &.active {
                    color: $color-primary;
                }
                &.accent {
                    background: $color-primary;
                    border-radius: 5px;
                    color: $color-white;
                    margin-left: 10px;
                    padding: 10px 15px;
                    &:hover {
                        background: $color-primary;
                        color: $color-white;
                    }
                }
            }
        }
    }

    .logo {
        align-items: center;
        text-decoration: none;
        transition: opacity .3s;
        &:hover {
            opacity: 0.7;
        }
        span {
            @include font-semibold(16px);
            line-height: normal;
        }
    }

</style>

<script>

import DropdownLang from '@cmp/DropdownLang';
import DropdownUser from '@cmp/DropdownUser';
import Hamburger from '@cmp/Hamburger';

export default {

    components: {
        'v-dropdown-lang': DropdownLang,
        'v-dropdown-user': DropdownUser,
        'v-hamburger': Hamburger,
    },

    computed: {

        loading() {
            return this.$store.getters.loading;
        },

        isHome() {
            return this.$route.name === 'home';
        },

        apiKey() {
            return this.$store.getters.apiKey;
        },

        agency() {
            return this.$store.getters.agency;
        },

        agencyName() {
            return this.agency?.name;
        },

        agencyIcon() {
            return this.agency?.icon?.link;
        },

    },

}

</script>
